// Getting Started
import Vue from 'vue'
import Form from './index.vue'
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueClipboard);
Vue.use(VueAxios, axios);

const IPv4 = new Vue({
    render: h => h(Form),
}).$mount('#ipv4');